import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
} from '@mui/material';

const ContactPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa', pt: 8 }}>
      <Container maxWidth="lg">
        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h3" gutterBottom color="primary">
            Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            We'd love to hear from you! Whether you have questions about our tools, feedback on our platform, or ideas for new features, we're here to help.
          </Typography>
          
          <Grid container spacing={4} sx={{ mt: 4 }}>
            <Grid item xs={12} md={6}>
              <Typography variant="h5" gutterBottom color="secondary">
                Get in Touch
              </Typography>
              <Box component="form" sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  label="Name"
                  variant="outlined"
                  margin="normal"
                />
                <TextField
                  fullWidth
                  label="Email"
                  variant="outlined"
                  margin="normal"
                  type="email"
                />
                <TextField
                  fullWidth
                  label="Subject"
                  variant="outlined"
                  margin="normal"
                />
                <TextField
                  fullWidth
                  label="Message"
                  variant="outlined"
                  margin="normal"
                  multiline
                  rows={4}
                />
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                >
                  Send Message
                </Button>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Typography variant="h5" gutterBottom color="secondary">
                Connect With Us
              </Typography>
              <Typography variant="body1" paragraph>
                Follow us on social media for updates, tips, and community stories.
              </Typography>
              <Typography variant="body1" paragraph>
                Join our community of coaches, organizers, and community builders who are making a difference.
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default ContactPage;
